export const team = [
  { name: "Prophet Paul Bamikole", image: "/team/Prophet-Paul-Bamikole.jpg", mark: "PB", tone: "team-amber" },
  { name: "YTD", image: "/team/YTD.jpeg", mark: "YTD", tone: "team-blue" },
  { name: "Kelvin Alabi", image: "/team/Kelvin Alabi.png", mark: "KA", tone: "team-coral" },
  { name: "Mercy Royalty", image: "/team/Mercy Royalty.jpg", mark: "MR", tone: "team-moss" },
  { name: "Joshua Balogun", image: "/team/Joshua-Balogun.jpg", mark: "JB", tone: "team-amber" },
  { name: "Priscilla Bamidele", image: "/team/Priscilla-Bamidele.jpg", mark: "PB", tone: "team-blue" },
  { name: "Yene Philips", image: "/team/Yene-Philips.jpg", mark: "YP", tone: "team-coral" },
  { name: "Samuel Gbemiga", image: "/team/samuel-gbemigaa.jpg", mark: "SG", tone: "team-moss" },
  { name: "David Bamidele", image: "/team/David-Bamidele2.jpg", mark: "DB", tone: "team-amber" },
];